export default {"src":"/_next/static/media/ASTC.9da85319.svg","height":18,"width":18};